import { screenshotsAccordion } from '../utils/screenshots';

document.addEventListener('DOMContentLoaded', function (e) {
  function initializeFeature(containerId) {
    var container = document.querySelector('#' + containerId);
    if (!container) return; // Stop if container doesn't exist

    var menuItems = container.querySelectorAll('.module-text-item');
    var imageDisplay = container.querySelector('.image-display');
    var imageToChange = container.querySelector('.image-display img'); // Assuming the img is directly under .image-display
    var imageDefaultSrc = imageDisplay.getAttribute('data-image-default');
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;

    if (imageDisplay && imageToChange && menuItems.length > 0) {
      function changeImage(item) {
        var imageSrc = item.getAttribute('data-image') || imageDefaultSrc;
        imageToChange.src = imageSrc;
      }

      function showItemImageMobile(item) {
        var itemImageDiv = item.querySelector('.module-text-item-image');
        if (itemImageDiv) {
          itemImageDiv.style.display =
            itemImageDiv.style.display === 'block' ? 'none' : 'block';
        }
      }

      function removeAllActiveClasses() {
        menuItems.forEach(function (item) {
          item.classList.remove('active');
        });
      }

      var firstItem = menuItems[0];
      changeImage(firstItem);
      firstItem.classList.add('active');

      menuItems.forEach(function (item) {
        if (isTouchDevice) {
          item.addEventListener('click', function () {
            menuItems.forEach(
              (i) =>
                (i.querySelector('.module-text-item-image').style.display =
                  'none')
            );
            removeAllActiveClasses();
            showItemImageMobile(item);
            item.classList.add('active');
          });
        } else {
          item.addEventListener('mouseenter', function () {
            removeAllActiveClasses();
            changeImage(item);
            item.classList.add('active');
          });
        }
      });
    }
  }

  // Initialize the feature for both divs
  initializeFeature('screenshots-hv2-feature-1');
});
